import React from "react";
import { DownloadOutlined, InfoCircleOutlined, QuestionCircleFilled } from "@ant-design/icons";
import "../assets/import-template-help.css";

export default function ImportTemplateHelp({ collaborationService, localize }) {
  if (collaborationService !== "wowtalk" && collaborationService !== "teams") return null;

  const guide = localize.ImportTemplateGuide;
  const isWowTalk = collaborationService === "wowtalk";
  const fields = [
    { key: "email", required: true, example: "member@example.com" },
    { key: "displayName", required: true, example: guide.nameExample },
    ...(isWowTalk ? [{ key: "linkId", example: "yamada01" }] : []),
    { key: "department", example: isWowTalk ? guide.wowtalkDepartmentExample : guide.teamsDepartmentExample },
    { key: "isAdmin", required: true, example: "0" },
  ];

  return (
    <section className="import-template-help" aria-labelledby="import-template-help-title">
      <h2 id="import-template-help-title" className="import-template-help__heading">
        <QuestionCircleFilled aria-hidden="true" />
        {localize.Help}
      </h2>
      <div className="import-template-help__guide">
        <div className="import-template-help__header">
          <div>
            <h3>{guide.title}</h3>
            <p className="import-template-help__service">
              {guide.format.replace("{service}", isWowTalk ? "WowTalk" : "Microsoft Teams").replace("{count}", fields.length)}
            </p>
          </div>
          <a
            className="import-template-help__download"
            href={`https://doc.wowdesk.jp/wowdesk_userimport_${collaborationService}.csv`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DownloadOutlined aria-hidden="true" />
            {localize.LinkTitle}
          </a>
        </div>

        <ol className="import-template-help__steps">
          {guide.steps.map((step, index) => (
            <li key={step.title}>
              <span className="import-template-help__number" aria-hidden="true">{index + 1}</span>
              <div>
                <h4>{step.title}</h4>
                <p>{step.description}</p>
              </div>
            </li>
          ))}
        </ol>

        <p className="import-template-help__notice">
          <InfoCircleOutlined aria-hidden="true" />
          <span><strong>{guide.immediateImport}</strong> {guide.overwriteNotice}</span>
        </p>

        <details className="import-template-help__details">
          <summary>{guide.detailsTitle}</summary>
          <div className="import-template-help__details-body">
            <p className="import-template-help__example-note">{guide.exampleNotice}</p>
            <dl className="import-template-help__fields">
              {fields.map((field) => (
                <div className="import-template-help__field" key={field.key}>
                  <dt>
                    <code>{field.key}</code>
                    <span className={`import-template-help__badge${field.required ? " import-template-help__badge--required" : ""}`}>
                      {field.required ? guide.required : guide.optional}
                    </span>
                  </dt>
                  <dd>
                    <p>{field.key === "department" ? (isWowTalk ? guide.wowtalkDepartment : guide.teamsDepartment) : guide.fields[field.key]}</p>
                    <p className="import-template-help__example">{guide.exampleLabel} <code>{field.example}</code></p>
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </details>
      </div>
    </section>
  );
}
